'use strict';

import anthroConfig from './anthroConfig';
import apiConfig from './apiConfig';
import contentfulConfig from './contentfulConfig';
import cookieConfig from './cookieConfig';
import eventsConfig from './eventsConfig';
import i18nConfig from './i18nConfig';

export const LegacyConfigs = angular.module('legacy.configs', [])
    .constant('AnthroConfig', anthroConfig)
    .constant('ApiConfig', apiConfig)
    .constant('ContentfulConfig', contentfulConfig)
    .constant('CookieConfig', cookieConfig)
    .constant('EventsConfig', eventsConfig)
    .constant('I18nConfig', i18nConfig);

export default LegacyConfigs;
